import React, { useState, useEffect } from 'react'
import { Typography, withStyles, TextField, Popover } from '@material-ui/core'
import { ChromePicker } from 'react-color'
import styles from './styles'

const HeaderSettingsColors = ({
  classes,
  colorProperties,
  onThemeSettingsChange,
}) => {
  // State for popover anchors
  const [backgroundColorAnchorEl, setBackgroundColorAnchorEl] = useState(null)
  const [textColorAnchorEl, setTextColorAnchorEl] = useState(null)

  // Local state for color pickers
  const [backgroundColor, setBackgroundColor] = useState(
    colorProperties.backgroundColor,
  )
  const [textColor, setTextColor] = useState(colorProperties.textColor)

  useEffect(() => {
    setBackgroundColor(colorProperties.backgroundColor)
    setTextColor(colorProperties.textColor)
  }, [colorProperties])

  // Handle color property changes
  const handleColorPropertyChange = (property, value) => {
    // Ensure # prefix is always present
    let sanitizedValue = value.replace(/#/g, '')
    sanitizedValue = '#' + sanitizedValue
    const updatedColors = {
      ...colorProperties,
      [property]: sanitizedValue,
    }
    onThemeSettingsChange('colorProperties', updatedColors)
  }

  // Handle background color picker
  const handleBackgroundColorClick = event => {
    setBackgroundColor(colorProperties.backgroundColor)
    setBackgroundColorAnchorEl(event.currentTarget)
  }

  const handleBackgroundColorClose = () => {
    handleColorPropertyChange('backgroundColor', backgroundColor)
    setBackgroundColorAnchorEl(null)
  }

  const handleBackgroundColorChange = color => {
    setBackgroundColor(color.hex)
  }

  // Handle text color picker
  const handleTextColorClick = event => {
    setTextColor(colorProperties.textColor)
    setTextColorAnchorEl(event.currentTarget)
  }

  const handleTextColorClose = () => {
    handleColorPropertyChange('textColor', textColor)
    setTextColorAnchorEl(null)
  }

  const handleTextColorChange = color => {
    setTextColor(color.hex)
  }

  return (
    <div className={classes.imageContent}>
      {/* Color Controls */}
      <div className={classes.colorControlsContainer}>
        {/* Background Color and Text Color */}
        <div className={classes.colorRow}>
          <div className={classes.colorField}>
            <Typography className={classes.colorLabel}>
              Header background color
            </Typography>
            <div className={classes.colorInputContainer}>
              <div
                className={classes.colorPickerBg}
                onClick={handleBackgroundColorClick}
              >
                <span
                  className={classes.colorPickerSpan}
                  style={{ backgroundColor: colorProperties.backgroundColor }}
                />
              </div>
              <TextField
                value={colorProperties.backgroundColor}
                onChange={e =>
                  handleColorPropertyChange('backgroundColor', e.target.value)
                }
                variant="outlined"
                size="small"
                className={classes.colorTextInput}
                placeholder="#FFFFFF"
              />
              <Popover
                open={Boolean(backgroundColorAnchorEl)}
                anchorEl={backgroundColorAnchorEl}
                className={classes.popover}
                onClose={handleBackgroundColorClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <ChromePicker
                  color={backgroundColor}
                  onChange={handleBackgroundColorChange}
                />
              </Popover>
            </div>
          </div>
          <div className={classes.colorField}>
            <Typography className={classes.colorLabel}>Text color</Typography>
            <div className={classes.colorInputContainer}>
              <div
                className={classes.colorPickerBg}
                onClick={handleTextColorClick}
              >
                <span
                  className={classes.colorPickerSpan}
                  style={{ backgroundColor: colorProperties.textColor }}
                />
              </div>
              <TextField
                value={colorProperties.textColor}
                onChange={e =>
                  handleColorPropertyChange('textColor', e.target.value)
                }
                variant="outlined"
                size="small"
                className={classes.colorTextInput}
                placeholder="#002E47"
              />
              <Popover
                open={Boolean(textColorAnchorEl)}
                anchorEl={textColorAnchorEl}
                className={classes.popover}
                onClose={handleTextColorClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <ChromePicker
                  color={textColor}
                  onChange={handleTextColorChange}
                />
              </Popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsColors)
